module.exports = __webpack_public_path__ + "static/组 12.c14623e7.png";